<template>
  <section>
    <b-row>
      <b-col sm="12" md="6">
        <p class="text-info">
          <strong>Critères d'évaluation pour les sources</strong>
        </p>
        <div class="text-right my-3">
          <b-icon
            class="mr-2"
            variant="secondary"
            icon="info-circle-fill"
          ></b-icon>
          <small
            >Cliquez directement sur la case pour faire vos changements.</small
          >
        </div>
        <b-table
          bordered
          :items="grid.reference_criteria ? grid.reference_criteria : []"
          stacked="md"
          :fields="fields"
          small
        >
          <template v-slot:cell(shortcut)="row">
            <b-form-input
              :ref="`shortcut${row.item.id}`"
              class="grid-input"
              type="text"
              :value="row.item.shortcut"
              @change="onChange(row, $event)"
              :state="valid.shortcut[row.item.id]"
            ></b-form-input>
          </template>
          <template v-slot:cell(comment)="row">
            <b-form-input
              :ref="`comment${row.item.id}`"
              class="grid-input"
              type="text"
              :value="row.item.comment"
              @change="onChange(row, $event)"
              :state="valid.comment[row.item.id]"
            ></b-form-input>
          </template>
          <template v-slot:cell(points)="row">
            <b-form-input
              :ref="`points${row.item.id}`"
              class="text-center grid-input"
              type="number"
              min="0"
              max="100"
              :state="valid.points[row.item.id]"
              :value="getGridValue(row, 1) ? getGridValue(row, 1).points : ''"
              @change="onChange(row, $event)"
            ></b-form-input>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </section>
</template>

<script>
/**
 * @file       Reference grid component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import Vue from "vue";
import { debounce } from "lodash";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "gridRefrence",
  props: {
    grid: {
      type: Object,
      default: () => {},
      required: true
    }
  },

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      fields: [
        {
          key: "shortcut",
          label: "Votre raccourci"
        },
        {
          key: "comment",
          label: "Rétroaction montrée au participant"
        },
        {
          key: "points",
          label: "Points",
          class: "text-center"
        }
      ],
      valid: { shortcut: {}, comment: {}, points: {} }
    };
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Get grid value.
     *
     * @param      {Object}  row     The row
     */
    getGridValue(row) {
      const found = row.item.reference_criteria_has_grid.find(r => r);
      return found ? found : "";
    },

    /**
     * Change grid.
     *
     * @param      {Object}  row     The row
     * @param      {string}  value   The value
     */
    onChange: debounce(function(row, value) {
      const item = this.getGridValue(row);

      this.update(row, item, value);
    }, 350),

    /**
     * Update the grid.
     *
     * @param      {Object}  row     The row
     * @param      {Object}  item    The item
     * @param      {string}  value   The value
     */
    update(row, item, value) {
      const payload = {};
      payload[row.field.key] = value;
      payload.reference_criteria_grid = row.item.id;

      Vue.set(this.valid[row.field.key], row.item.id, false);

      this.$store
        .dispatch("grid/putGridReference", payload)
        .then(() => {
          Vue.set(this.valid[row.field.key], row.item.id, null);

          this.$root.$bvToast.toast("Mise à jour effectuée avec succès.", {
            title: "Succès"
          });
        })
        .catch(() => {
          Vue.set(this.valid[row.field.key], row.item.id, null);
          this.$nextTick(() => {
            this.$refs[`${row.field.key}${row.item.id}`].$el.value =
              row.item[row.field.key];
          });
          this.$root.$bvToast.toast("La mise à jour à échouée", {
            title: "Erreur",
            variant: "danger"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-input {
  border: none;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
}
</style>
